import generateId from '../tools/idGenerator';

//unique id used to represent the user client session, primarily used so subscriptions don't receieve
//messages based on actions the current app triggered
export const sessionId = encodeURIComponent(generateId());
